import React from 'react'
import AboutComponent from '../components/AboutComponent'
import FAQs from '../components/FAQs'

const AboutUs = () => {
  return (
    <div>
        <AboutComponent/>
        <FAQs/>
    </div>
  )
}

export default AboutUs

